import { CallCenterContactDTO } from '../dtos/call-center'

export interface CallCenterContact {
  id: string
  email: string
  firstName?: string
  lastName?: string
  phone?: string
  contactType?: string
  signedUpForWaitlist: boolean
  waitlistWorkspaceId?: string
  createdAt: string
  updatedAt: string
}

export function mapCallCenterContact(
  dto: CallCenterContactDTO,
): CallCenterContact {
  return {
    id: dto.id,
    email: dto.email,
    firstName: dto.firstname,
    lastName: dto.lastname,
    phone: dto.phone,
    contactType: dto.contact_type,
    signedUpForWaitlist: dto.signed_up_for_waitlist,
    waitlistWorkspaceId: dto.waitlist_workspace_id,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
